export default class BackToTop {
  constructor( node ) {
    this.node = node;
    this.windowPosition = window.pageYOffset;
    this.delayPosition = 0;
    this.handleWindowHeight();
    this.handleScrollEvent();
    this.handleClickEvent();
  }
  handleWindowHeight() {
    let hWindow = window.innerHeight;
    let divider = document.querySelectorAll( '.divider' );

    if ( divider.length === 1 ) {
      let hDivider = divider[ 0 ].clientHeight;
      if ( hWindow > hDivider ) {
        this.node.classList.add( 'back-to-top--hidden' );
      }
    }
  }
  handleScrollEvent() {
    window.addEventListener( 'scroll', () => {

      if ( window.pageYOffset < 100 || document.querySelector( '#main' ).getBoundingClientRect().bottom - window.innerHeight <= 0 ) {
        if ( this.node.classList.contains( 'back-to-top--fixed' )) {
          this.node.classList.remove( 'back-to-top--fixed' );
        }
      } else {
        if ( this.windowPosition < window.pageYOffset && this.node.classList.contains( 'back-to-top--fixed' )) {
          this.node.classList.remove( 'back-to-top--fixed' );
        } else if ( this.windowPosition < window.pageYOffset ) {
          this.delayPosition = 0;
        } else if ( this.windowPosition > window.pageYOffset && !this.node.classList.contains( 'back-to-top--fixed' ) && this.delayPosition >= 50 ) {
          this.node.classList.add( 'back-to-top--fixed' );
        }
      }

      this.windowPosition = window.pageYOffset;
      this.delayPosition += 10;
    });
  }
  handleClickEvent() {
    this.node.addEventListener( 'click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}
